import { ProperPageResult } from '../../../model/proper-page-result';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SnackService } from 'src/app/services/snack.service';
import { LoadingService } from 'src/app/services/loading.service';
import { Router } from '@angular/router';
import { SubProject } from 'src/app/model/project/sub-project';
import { KeyValue } from '@angular/common';
import { StringHelper } from 'src/app/helpers/string-helper';
import { Observable } from 'rxjs';
import { _get } from '../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class MostRecentPlacementControllerRequestService {
  private static BASE_URL = '/subprojects/mostRecentPlacements';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserializePaged = (res) => {
    const result: ProperPageResult<SubProject> = new ProperPageResult();
    result.totalItems = res.totalItems;
    result.items = res.items;
    return result;
  };

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      MostRecentPlacementControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public getPage(
    placerId?: number,
    typeCriteria?: KeyValue<string, string>
  ): Promise<ProperPageResult<SubProject>> {
    const pathParams: string = StringHelper.join(
      [
        placerId == null ? null : `placerId=${placerId}`,
        typeCriteria == null
          ? null
          : `${typeCriteria.key}=${typeCriteria.value}`,
      ],
      '&'
    );
    const pathParamsValue = StringHelper.isEmpty(pathParams)
      ? ''
      : `?${pathParams}`;

    return this.get(pathParamsValue, this.deserializePaged).toPromise();
  }
}
